import i18n, { Resource, ResourceLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, getStoredLanguage } from './language';

/**
 * Auto-discover every locale file under ./locales/<lng>/<namespace>.json.
 * Using Vite's glob import means new namespace files are picked up automatically —
 * no central edit required, so modules can be translated independently.
 */
const localeFiles = import.meta.glob<{ default: Record<string, unknown> }>('./locales/**/*.json', {
  eager: true,
});

const resources: Resource = {};

for (const path in localeFiles) {
  const match = path.match(/\.\/locales\/([^/]+)\/(.+)\.json$/);
  if (!match) continue;
  const [, lng, namespace] = match;
  const bundle = (resources[lng] as ResourceLanguage) ?? (resources[lng] = {} as ResourceLanguage);
  bundle[namespace] = localeFiles[path].default;
}

const namespaces = Object.keys(resources[DEFAULT_LANGUAGE] ?? {});

i18n.use(initReactI18next).init({
  resources,
  lng: getStoredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  defaultNS: 'common',
  fallbackNS: 'common',
  ns: namespaces.length ? namespaces : ['common'],
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: false,
});

export default i18n;
